import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './config/router'
import http from './utils/http'
import Components from './components/index';
import store from './config/store';
import mixin from './utils/mixin'
import * as filters from './filters'
import uploader from "vue-simple-uploader";

import i18n from './lang'



Vue.mixin(mixin);
Vue.use(uploader)

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

var config = {};
config.api_url = 'https://18-22.com.hk/';

Vue.prototype.$config = config;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$http = http
http.init({
  baseURL:config.api_url,
  timeout: 30000 // request timeout
})

if (process.env.NODE_ENV === 'production') {
//  new VConsole()
}
//警告
Vue.config.silent = true
//
Vue.config.productionTip = false;
//使用elementui
Vue.use(ElementUI);

//注册全局组件
Vue.use(Components);

// Vue.directive('title', {
//   inserted: function (el, binding) {
//     // document.title = el.dataset.title
//     document.title = binding.value
//   }
// })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
